import { render, staticRenderFns } from "./DetailsModel.vue?vue&type=template&id=4497d5f0&scoped=true&"
import script from "./DetailsModel.vue?vue&type=script&lang=js&"
export * from "./DetailsModel.vue?vue&type=script&lang=js&"
import style0 from "./DetailsModel.vue?vue&type=style&index=0&id=4497d5f0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4497d5f0",
  null
  
)

export default component.exports